import { Route, Routes, Navigate } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import SalesDashboard from "../../pages/sales/SalesDashboard";
import ScopingSessionDetails from "../../pages/sales/ScopingSessionDetails";
import SowEditorPage from "../../pages/sales/sow/SowEditorPage";
import QuestionnaireTemplatesPage from "../../pages/sales/QuestionnaireTemplatesPage";
import ScopingIntakesPage from "../../pages/sales/ScopingIntakesPage";
import AdminProfile from "../../pages/admin/AdminProfile";
import OrgSettingsPage from "../../pages/settings/OrgSettingsPage";
import NotificationsPage from "../../pages/notifications/NotificationsPage";

const SolutionsSpecialistRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="sales" />} />
      <Route path="sales" element={<SalesDashboard />} />
      <Route path="sales/intakes" element={<ScopingIntakesPage />} />
      <Route path="sales/scoping/:id" element={<ScopingSessionDetails />} />
      <Route path="sales/scoping/:id/sow" element={<SowEditorPage />} />
      <Route path="sales/templates" element={<QuestionnaireTemplatesPage />} />
      <Route path="profile/*" element={<AdminProfile />} />
      <Route path="settings/*" element={<OrgSettingsPage />} />
      <Route path="notifications" element={<NotificationsPage />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
};

export default SolutionsSpecialistRoutes;
